import Cookies from 'js-cookie';

const user = {
  state: {
    id:Cookies.get('admin_id'),
    name: Cookies.get('admin_name'),
    token: Cookies.get('admin_token'),
    max: Cookies.get('admin_max'),
    dw: Cookies.get('admin_dw')
  },

  getters: {
    token: (state) => {
      return state.token;
    },
    name: (state) => {
      return state.name;
    },
    id: (state) => {
      return state.id;
    },
    max: (state) => {
      return state.max;
    },
    dw: (state) => {
      return state.dw;
    },
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      Cookies.set('admin_token', token);
      //Cookies.set('admin_token', token,{expires: 1});
      state.token = token;
    },
    SET_ID: (state, id) => {
      Cookies.set('admin_id', id);
      state.id = id;
    },
    SET_NAME: (state, name) => {
      Cookies.set('admin_name', name);
      state.name = name;
    },
    SET_MAX: (state, max) => {
      Cookies.set('admin_max', max);
      state.max = max;
    },
    SET_DW: (state, dw) => {
      Cookies.set('admin_dw', dw);
      state.dw = dw;
    }
  },

  actions: {
    // 获取用户信息
    GetInfo({ commit, state }) {
      // return new Promise((resolve, reject) => {
      //   getInfo(state.token).then(response => {
      //     const data = response.data;
      //     commit('SET_ROLES', data.role);
      //     commit('SET_NAME', data.name);
      //     commit('SET_AVATAR', data.avatar);
      //     commit('SET_UID', data.uid);
      //     commit('SET_INTRODUCTION', data.introduction);
      //     resolve(response);
      //   }).catch(error => {
      //     reject(error);
      //   });
      // });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          Cookies.remove('Admin-Token');
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        Cookies.remove('Admin-Token');
        location.reload();
        resolve();
      });
    },

  }
};

export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js